import axios from 'axios'
import {axiosConfig} from '@/config/axiosConfig.js'

export const update_time_ajax = (client_name) => {
    return axios.post(`${client_name}/webmap/user_updatetime/`, {}, axiosConfig);
}

export const get_webmap_ajax = (client_name, option_params = {}) => {
    return axios.get(`${client_name}/webmap/webmap_json/`, {...option_params, ...axiosConfig})
}

export const get_webmap_json_init_ajax = (client_name, option_params = {}) => {
    return axios.get(`${client_name}/webmap/webmap_json_init/`, {...option_params, ...axiosConfig})
}

export const get_webmap_past_ajax = (client_name, start_time, end_time, option_params = {}) => {
    return axios.get(`${client_name}/webmap/webmap_json/start_time/${start_time}/end_time/${end_time}`, {...option_params, ...axiosConfig})
}

export const get_map_config_ajax = (client_name, option_params = {}) => {
    return axios.get(`${client_name}/webmap/get_default_basemapconfig/`, {...option_params, ...axiosConfig})
}

export const get_geomap_ajax = (client_name, option_params = {}) => {
    return axios.get(`${client_name}/webmap/geomap_json/`, {...option_params, ...axiosConfig});
}

export const get_remote_file_ajax = (path) => {
    return axios.get(path)
}

export const get_previous_link_ajax = (client_name) => {
    return axios.get(client_name + '/webmap/set_previous_link/', axiosConfig);
}